import React, { useContext, useEffect } from 'react';
import { Steps, Panel } from 'rsuite';
import { useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';

import BasicInfo from './BasicInfo';
import IssuerReceiver from './IssuerReceiver';
import InvoiceLines from '../StepperComponents/InvoiceLines';
import OrderPayment from '../StepperComponents/OrderPayment';
import Delivery from '../StepperComponents/Delivery';
import Summary from '../StepperComponents/Summary';

import DataContext from '../context/InvoiceData';

function Stepper() {
  const { state } = useLocation();
  const { showToast } = state || {};

  const { step, invoiceSubType } = useContext(DataContext);
  const { t, i18n } = useTranslation();

  let showStepComponent = step => {
    if (['', 'default'].includes(invoiceSubType)) {
      switch (step) {
        case 0:
          return <BasicInfo />;
        case 1:
          return <IssuerReceiver />;
        case 2:
          return <InvoiceLines />;
        case 3:
          return <OrderPayment />;
        case 4:
          return <Delivery />;
        case 5:
          return <Summary />;

        default:
          break;
      }
    } else {
      switch (step) {
        case 0:
          return <BasicInfo />;
        case 1:
          return <IssuerReceiver />;
        case 2:
          return <InvoiceLines />;
        case 3:
          return <Summary />;

        default:
          break;
      }
    }
  };

  useEffect(() => {
    if (showToast) {
      toast.success(`Invoice Created Successfully`, {
        position: 'top-right',
        autoClose: 1000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: 'colored',
      });
    }
  }, []);

  return (
    <>
      {['', 'default'].includes(invoiceSubType) ? (
        <Steps current={step} className='mx-5 mt-4'>
          <Steps.Item title={t('stepper.basicInfo.title')} />
          <Steps.Item className='text-nowrap' title={t('stepper.issuerReceiver.title')} />
          <Steps.Item title={t('stepper.invoiceLines.title')} />
          <Steps.Item className='text-nowrap' title={t('stepper.payment.title')} />
          <Steps.Item title={t('stepper.delivery.title')} />
          <Steps.Item title={t('stepper.summary.title')} />
        </Steps>
      ) : (
        <Steps current={step} className='mx-5 mt-4'>
          <Steps.Item title={t('stepper.basicInfo.title')} />
          <Steps.Item className='text-nowrap' title={t('stepper.issuerReceiver.title')} />
          <Steps.Item title={t('stepper.invoiceLines.title')} />
          <Steps.Item title={t('stepper.summary.title')} />
        </Steps>
      )}

      <Panel>{showStepComponent(step)}</Panel>
    </>
  );
}

export default Stepper;
